<template>
  <div
    class="sellerRegister"
    :class="locale == 'en' ? 'backgroundLtl' : 'backgroundRtl'"
  >
    <v-container>
      <v-row>
        <v-col cols="12" md="6">
          <h1 class="text-center second-color">
            {{ $t("createSellerAccount") }}
          </h1>
          <h2 class="title second-color">{{ $t("sellerDetails") }}</h2>
          <v-divider color="#13a8b1" class="mb-2"></v-divider>
          <v-form ref="form" v-model="valid">
            <v-row>
              <v-col cols="12" sm="6">
                <label for="name" class="main-color">{{ $t("name") }} *</label>
                <v-text-field
                  v-model="seller.first_name"
                  dense
                  :rules="[validationRules.required, validationRules.spaces]"
                  solo
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <label for="name" class="main-color"
                  >{{ $t("familyName") }} *</label
                >
                <v-text-field
                  v-model="seller.family_name"
                  dense
                  solo
                  :rules="[validationRules.required, validationRules.spaces]"
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6">
                <label for="title" class="main-color"
                  >{{ $t("title") }} *</label
                >
                <v-radio-group
                  row
                  color="#ffffff"
                  v-model="seller.title"
                  :rules="[validationRules.required]"
                >
                  <v-radio :label="$t('Mr.')" value="mr"></v-radio>
                  <v-radio :label="$t('Ms.')" value="ms"></v-radio>
                </v-radio-group>
              </v-col>

              <v-col cols="12" sm="6">
                <label for="birthdate" class="main-color"
                  >{{ $t("dateOfBirth") }} *</label
                >
                <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="seller.birthdate"
                      label
                      append-icon="event"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      solo
                      dense
                      :rules="[validationRules.required]"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="seller.birthdate"
                    @input="menu2 = false"
                    :max="nowDate"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>

            <v-row>
              <v-col
                cols="4"
                sm="4"
                style="padding-left: 0px; padding-right: 0"
              >
                <label for="name" class="main-color">{{ $t("mobil") }}*</label>

                <div
                  class="code applicant-country-code"
                  id="country-code"
                  style="direction: ltr !important"
                >
                  <!-- <v-autocomplete
                    :items="Codes"
                    item-text="code"
                    item-value="id"
                    value="187"
                    solo
                    @focus="onFocus"
                    :rules="[validationRules.required]"
                    v-model="seller.country_code_id"
                    dense
                  ></v-autocomplete> -->

                  <v-autocomplete
                    :items="dataObject.Codes"
                    class="form-control"
                    id="countryCodeId"
                    @change="changeCountryCode"
                    item-text="title"
                    item-value="value"
                    :value="187"
                    @focus="onFocus"
                    :rules="[validationRules.required]"
                    v-model="seller.country_code_id"
                    dense
                    solo
                    ><template slot="selection" slot-scope="data">
                      <v-flex xs2>
                        <!-- <v-avatar size="25px"> -->
                        <img :src="data.item.icon" class="flag-img" />
                        <!-- </v-avatar> -->
                      </v-flex>
                      <v-flex class="ml-4">
                        {{ data.item.title }}
                      </v-flex>
                    </template>
                    <template slot="item" slot-scope="data">
                      <!-- <v-list-item-avatar
                                  style="width: 20px; min-width: 20px; height: 20px;"
                                > -->
                      <img :src="data.item.icon" class="flag-img" />
                      <!-- </v-list-item-avatar> -->
                      <v-list-item-content>
                        <v-list-item-title
                          v-html="data.item.title"
                        ></v-list-item-title>
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                </div>
              </v-col>
              <v-col cols="8" sm="8">
                <!-- <label for style="visibility: hidden;">fsadf</label> -->
                <v-text-field
                  class="mt-5"
                  dense
                  solo
                  v-model="seller.mobile"
                  :rules="[
                    validationRules.required,
                    validationRules.numeric,
                    validationRules.spaces,
                  ]"
                >
                </v-text-field>
                <div
                  class="validationError"
                  v-if="validationErrors && validationErrors.mobile"
                >
                  <p
                    class="error--text backend-error"
                    v-for="(error, index) in validationErrors.mobile"
                    :key="index"
                  >
                    <span style="color: #000">{{ error }}</span>
                  </p>
                </div>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="6">
                <label for="name" class="main-color">{{ $t("email") }} *</label>
                <v-text-field
                  dense
                  solo
                  v-model="seller.email"
                  :rules="[
                    validationRules.required,
                    validationRules.email,
                    validationRules.spaces,
                  ]"
                >
                </v-text-field>
                <div
                  class="validationError"
                  v-if="validationErrors && validationErrors.email"
                >
                  <p
                    class="error--text backend-error"
                    v-for="(error, index) in validationErrors.email"
                    :key="index"
                  >
                    <span style="color: #000">{{ error }}</span>
                  </p>
                </div>
              </v-col>
              <v-col cols="12" sm="6">
                <label for="name" class="main-color"
                  >{{ $t("password") }} *</label
                >
                <v-text-field
                  dense
                  solo
                  v-model="seller.password"
                  :rules="[
                    validationRules.required,
                    validationRules.password,
                    validationRules.spaces,
                  ]"
                  :append-icon="togglePassword ? 'mdi-eye-off' : 'mdi-eye'"
                  @click:append="() => (togglePassword = !togglePassword)"
                  :type="togglePassword ? 'password' : 'text'"
                  class="password"
                >
                </v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="12">
                <h2 class="title second-color">{{ $t("Shop Details") }}</h2>
                <v-divider color="#13a8b1" class="mb-2"></v-divider>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="6">
                <label for="name" class="main-color"
                  >{{ $t("Shop Name") }} *</label
                >
                <v-text-field
                  dense
                  solo
                  v-model="seller.shop_name"
                  :rules="[validationRules.required]"
                >
                </v-text-field>

                <div
                  class="validationError"
                  v-if="validationErrors && validationErrors.shop_name"
                >
                  <p
                    class="error--text backend-error"
                    v-for="(error, index) in validationErrors.shop_name"
                    :key="index"
                  >
                    <span style="color: red">{{ error }}</span>
                  </p>
                </div>
              </v-col>
              <v-col cols="12" sm="6">
                <label for="name" class="main-color"
                  >{{ $t("Country") }} *</label
                >
                <v-select
                  solo
                  dense
                  :items="countries"
                  item-text="name"
                  item-value="id"
                  @change="getCities"
                  v-model="selectedCountry"
                  :rules="[validationRules.required]"
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6">
                <label for="name" class="main-color">{{ $t("City") }} *</label>
                <v-autocomplete
                  v-model="seller.shop_city_id"
                  item-text="name"
                  item-value="id"
                  solo
                  :items="cities"
                  :rules="[validationRules.required]"
                  :disabled="loading"
                  dense
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6">
                <label for="name" class="main-color"
                  >{{ $t("Shop Address") }} *</label
                >
                <v-text-field
                  dense
                  solo
                  v-model="seller.shop_address"
                  :rules="[validationRules.required, validationRules.spaces]"
                >
                </v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="12">
                <h2 class="title second-color">
                  {{ $t("Seller Bank Account Information") }}
                </h2>
                <v-divider color="#13a8b1" class="mb-2"></v-divider>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="6">
                <label for="name" class="main-color">{{ $t("IBAN") }} *</label>
                <v-text-field
                  dense
                  solo
                  v-model="seller.bank_account_number"
                  :rules="[validationRules.required, validationRules.spaces]"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <label for="name" class="main-color">{{
                  $t("accountBankInfo")
                }}</label>
                <v-file-input
                  dense
                  label=""
                  @change="onAddFile"
                  accept="image/*"
                  outlined
                ></v-file-input>
              </v-col>
            </v-row>

            <v-row v-if="endorsements.length > 0">
              <v-col cols="12" sm="12">
                <h2 class="title second-color">
                  {{ $t("Endorsements") }}
                </h2>
                <v-divider color="#13a8b1" class="mb-2"></v-divider>
              </v-col>
              <v-col>
                <!-- v-model="checkbox" -->
                <div
                  class="endors"
                  v-for="(item, index) in endorsements"
                  :key="index"
                >
                  <v-checkbox
                    class="mx-2"
                    style="color: #ffffff !important"
                    :label="item.text + ' *'"
                    v-model="item.value"
                    :rules="[validationRules.required]"
                  ></v-checkbox>
                </div>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-btn
                  class="primary-btn border-radius-10"
                  @click.prevent="submit"
                  :loading="loader"
                  :disabled="loader"
                  >{{ $t("sellerRegister") }}</v-btn
                >
              </v-col>
            </v-row>
          </v-form>
        </v-col>
      </v-row>
    </v-container>
    <Snack ref="snack"></Snack>
  </div>
</template>

<script>
import AUTH from "../../auth";
import { validationMixin } from "../../mixins/validationMixin";
export default {
  name: "SellerRegistration",
  mixins: [validationMixin],
  data() {
    return {
      togglePassword: true,
      loader: false,
      nowDate: new Date(Date.now() - 864e5).toISOString().slice(0, 10),
      menu2: false,
      loading: false,
      seller: {
        first_name: "",
        family_name: "",
        mobile: "",
        email: "",
        password: "",
        title: "",
        birthdate: "",
        country_code_id: "",
        shop_name: "",
        shop_address: "",
        shop_city_id: "",
        bank_account_number: "",
        bank_info: "",
      },
      countries: [],
      cities: [],
      Codes: [],
      hideLabel: false,
      dataObject: {
        Codes: [],
      },

      endorsements: [],
      validationErrors: [],
      selectedCountry: "",
      valid: false,
      type: AUTH.type(),
      isLoggedIn: AUTH.isLoggedIn("seller"),
    };
  },
  methods: {
    submitOnClick() {
      document.addEventListener("keydown", (event) => {
        if (event.keyCode === 13) {
          this.submit();
        }
        // do something
      });
    },
    submit() {
      this.validationErrors = [];
      if (this.valid == false) {
        this.validate();
      } else {
        this.loader = true;
        this.$http
          .post(this.getApiUrl + "/seller/register", this.seller)
          .then((response) => {
            this.loader = false;
            if (response.data.status.error == false) {
              localStorage.seller_email = response.data.data.user.email;
              localStorage.seller_registered = true;
              this.$router.push({ path: "/seller/activationCode" });
              // this.$refs.snack.sendSuccessAlert(response.data.status.message);
              this.validationErrors = [];
              this.seller = {
                first_name: "",
                family_name: "",
                mobile: "",
                email: "",
                password: "",
                title: "",
                country_code_id: "",
                shop_name: "",
                shop_address: "",
                shop_city_id: "",
                bank_account_number: "",
                bank_info: "",
              };
            } else {
              if (
                Object.keys(response.data.status.validation_errors).length > 0
              ) {
                this.validationErrors = response.data.status.validation_errors;
              } else {
                this.$refs.snack.sendErrorAlert(response.data.status.message);
              }
            }
          });
      }
    },
    getRegistrationData() {
      this.$http
        .get(this.getApiUrl + "/seller/seller-registration/data", {
          headers: {
            locale: localStorage.locale,
          },
        })
        .then((response) => {
          if (response.data.status.error == false) {
            this.countries = response.data.data.countries;
            this.endorsements = response.data.data.endorsements;
            this.Codes = response.data.data.country_codes;
          }
        });
    },
    onAddFile(File) {
      console.log(File);
      if (File) {
        const selectedImage = File;

        if (
          selectedImage &&
          selectedImage.type &&
          !selectedImage.type.startsWith("image")
        ) {
          this.bankAttachImgError = "مسموح بالصور فقط";
        } else {
          this.bankAttachImgError = "";
        }

        this.createBase64Image(selectedImage);
      }
    },
    createBase64Image(fileObject) {
      const reader = new FileReader();
      // const _this = this;
      reader.onload = (e) => {
        this.seller.bank_info = e.target.result;
      };
      reader.readAsDataURL(fileObject);
    },
    getCities() {
      this.loading = true;
      this.$http
        .get(this.getApiUrl + "/market/cities/" + this.selectedCountry, {
          headers: {
            locale: localStorage.locale,
          },
        })
        .then((response) => {
          if (response.data.status.error == false) {
            this.loading = false;
            this.cities = response.data.data;
          }
        });
    },

    onFocus() {
      this.validationErrors = {};
    },
    getCountryCodes() {
      this.$http.get(this.getApiUrl + "/getCodes").then((response) => {
        this.dataObject.Codes = response.data.data;
      });
    },
    changeCountryCode() {
      this.hideLabel = true;
      console.log(document.getElementById("countryCodeId"));
      document.getElementById("countryCodeId").blur();
    },
  },
  mounted() {
    if (AUTH.isLoggedIn("seller")) {
      this.$router.push({ path: "/seller/shop" });
    }
    console.log(AUTH.isLoggedIn("seller"));
    console.log(AUTH.type());
    this.getRegistrationData();
    this.getCountryCodes();
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/_variables.scss";

.backgroundRtl {
  background: url("../../assets/images/seller-background.png");
}
.backgroundLtl {
  background: url("../../assets/images/seller_background-rtl.png");
}

.sellerRegister {
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;
  background-position: center center;
  min-height: 100vh;

  .title {
    font-weight: bold !important;
  }
  .col,
  .col-sm-12,
  .col-12,
  .col-sm-2,
  .col-2,
  .col-sm-4,
  .col-4 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;

    .v-radio .v-icon,
    .v-radio .v-label {
      color: #ffffff !important;
    }
  }

  .primary-btn {
    width: 100%;
    font-weight: bold;
  }
  .border-radius-10 {
    border-radius: 10px !important;
  }
}
</style>